import React, { useContext, useEffect, useState } from "react"
import { InputBase, Input, Chip, CloseButton } from "@mantine/core"
import { css } from '@emotion/css';
import UserSelectionContext from "../../providers/UserSelectionProvider";
import { getHardcodedColor } from "../../utils";
import { nodeTypes } from "../../types";
import { getAllIndications } from "../../services/indication";
import { PiTreeView } from "react-icons/pi";
import UiStateContext from "../../providers/UiStateProvider";

interface SearchFieldProps {
  onOptionSelect: (option: string) => void;
}

const PillsListScrollbar = css`
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #828992 transparent;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #828992;
    border-radius: 10px;
    border: 2px solid transparent;
  }
`;


const IndicationFilterField: React.FC<SearchFieldProps> = ({ onOptionSelect }) => {
  const [data, setData] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { selectedIndications, SetSelectedIndications, focusedIndications, SetFocusedIndications, selectedMoa } = useContext(UserSelectionContext)
  const { SwitchMeshPanelOpened } = useContext(UiStateContext)

  useEffect(() => {
    const callGetAllIndications = async () => {
      const names = await getAllIndications();
      setData(names);
      setLoading(false)
    };
    callGetAllIndications()
  }, [])

  return (
    <InputBase
      component="button"
      type="button"
      disabled={!selectedMoa}
      pointer
      rightSection={<PiTreeView size={20} />}
      rightSectionPointerEvents="none"
      classNames={{
        input: PillsListScrollbar
      }}
      onClick={() => SwitchMeshPanelOpened()}
      styles={{
        input: {
          backgroundColor: 'rgb(198,198,206, 0.2)',
          border: 0,
          color: "#f3f3f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexWrap: "nowrap",
          overflowX: "auto",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          padding: "15px",
          gap: "5px",
        }
      }}
    >
      {selectedIndications && selectedIndications.size ?
        <Chip.Group>
          {[...selectedIndications].map((i) => (
            <Chip
              size="xs"
              value={i}
              color={getHardcodedColor(nodeTypes.disease)}
              checked={i === focusedIndications}
              onChange={() => SetFocusedIndications(i)}
            >
              {i}
              <CloseButton
                onClick={(e) => {
                  e.stopPropagation();
                  SetSelectedIndications((prevSelectedIndications: Set<string>) => {
                    const newSet = new Set(prevSelectedIndications);
                    newSet.delete(i);
                    return newSet;
                  });
                  // if(i === focusedIndications) {
                  //   SetFocusedIndications("");
                  // }
                }}
                size="xs"
                style={{ marginLeft: "5px" }}
              />
            </Chip>
          ))}
        </Chip.Group>
        : <Input.Placeholder>Select Indications</Input.Placeholder>}
    </InputBase>
  )
};

export default IndicationFilterField;
